import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getEncryptPseudonyms = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.encryptPseudonym.encryptPseudonyms.entries, filter);
};
